import React from "react";

// eslint-disable-next-line no-unused-vars
const AlphaWarning = props => {
    return (
        <div className="notification is-warning is-light">
            <p>This is an experimental hack by <a href='https://gwynmorfey.com'>Gwyn</a> (&amp; others). Don&apos;t use it for anything important.</p>
            <p>New (15 Jul 20): Added subtitle support.</p>
        </div>
    );
};

export default AlphaWarning;